module.exports = __webpack_public_path__ + "img/airplane.23d5f962.svg";